module.exports = __webpack_public_path__ + "static/media/icon-character__john-lennon-hover.4ac93acd.svg";